/* src/app/components/DisabledPage/index.js */

import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

import styles from './styles';

const DisabledPage = ({ classes, text }) => (
  <div className={classes.fillPage}>
    <Typography className={classes.text}>
      {text}
    </Typography>
  </div>
);

DisabledPage.propTypes = {
  classes: PropTypes.object.isRequired,
  text: PropTypes.string,
};

DisabledPage.defaultProps = {
  text: '',
};

export default withStyles(styles)(DisabledPage);



// WEBPACK FOOTER //
// ./src/app/components/DisabledPage/index.js